import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Component,
  OnInit,
  HostListener,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilService } from 'src/app/shared/helper/util.service';
import { GuidedTourService } from 'src/app/shared/services/guided-tour.service';
import { HomePageService } from 'src/app/shared/services/homepage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header-v2',
  templateUrl: './header-v2.component.html',
  styleUrl: './header-v2.component.scss'
})
export class HeaderV2Component {
  headerTabs: any = [];
  isHeaderTabVisible: boolean = false;
  userName: any;
  userId: string;
  private lastVisitedUrl: string = '';
  userType: string;
  isProfileCardOpen: boolean = false;
  backupLastVisitedUrl: string;
  sideHeaders: any = [];
  moduleByteMap: any;
  iconHeaders: any = [];
  allHeadersTab: any = [];
  accountSettingSvg = "../assets/images/settings-black.svg"
  errMsg: string = '';
  showErrorMessageWithPopup: boolean = false;
  isUserLoggedIn: boolean;
  subscriptionMsg = 'Please contact DMINT Administrator to get subscription of the same';
  closeSign: string;
  modulesForHiddenHeader: any[];

  showOverlayFlag: boolean=false;
  announcementDetails: any;
  announcementId: any;

  tourSteps: any[] = [
    // {
    //   topic: 'Improved Navigation',
    //   selector: '#tour-headerTab',
    //   description: 'The ‘Data Manager’ and ‘Capabilities’ sections have been merged into a single entity known as ‘Data Products’, thereby enhancing the overall user experience.'
    // },
    // {
    //   topic: 'Updated Labels',
    //   selector: '#tour-productTab',
    //   description: 'Capabilities is now ‘Data Products’ and ‘Data Manager’ is now ‘My Reports’ to better reflect their purpose.'
    // },
    // {
    //   topic: 'Product Card',
    //   selector: '#tour-productCard-0',
    //   description: 'We\'ve added a detailed product page to give you more insights and context for better understanding and decision-making.'
    // }
  ];
  showTourSub: any;
  isLoading: boolean = true;
  
  constructor(
    public auth: AuthService,
    private homePageService: HomePageService,
    private utilService: UtilService,
    private spinnerService: NgxSpinnerService,
    public router: Router,
    private http: HttpClient,
    private eRef: ElementRef,
    private tourService: GuidedTourService,
  ) {
    this.auth.getAccessTokenSilently().subscribe((res: any) => {
      localStorage.setItem('token', res);
    });
     this.showTourSub = this.tourService.showTour$.subscribe(show => {
      if (this.tourSteps?.length>0) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
  });
     this.showTourSub = this.tourService.showTourOnTabChange$.subscribe(show => {
       if(show){
        this.startTour();
      }
    });
  }
  callOverlay() {
    if(this.isUserLoggedIn)this.startTour();
  }
  getSelectedHeader(selectedHeader:any){
   this.utilService.setHeaderId(selectedHeader.id);
  }
  ngOnInit(): void {
    this.spinnerService.show();

    this.allHeadersTab = [];
    this.isUserLoggedIn = localStorage.getItem('id') != 'undefined'
    && localStorage.getItem('id') != undefined ? true : false;
    
    this.utilService.moduleBytes.subscribe((mod: any) => {
      this.moduleByteMap = mod as Object;
    });

    this.utilService.getUserId.subscribe((userId: any) => {
      if (userId != 'undefined')
        this.userId = userId;
    });


    this.spinnerService.show();
    this.auth.user$.subscribe((user) => {
      localStorage.setItem('id', user?.sub);
      this.userName = user?.name;

      this.isUserLoggedIn = localStorage.getItem('id') != 'undefined'
      && localStorage.getItem('id') != undefined ? true : false;

      if (localStorage.getItem('id') != 'undefined') {
        this.homePageService.getUserByAuthId().subscribe(
          (res: any) => {
            this.errMsg = '';
            const response = res;
            const result = response.result;
            const id = result?.id;

            localStorage.setItem('userId', id);
            this.utilService.userId(id);
            this.spinnerService.hide();
            this.isLoading = false;
            if (localStorage.getItem('userId') != 'undefined') {
              this.callHeader();
              this.userType = localStorage.getItem('userType');
              this.lastVisitedUrl = localStorage.getItem('lastVisitedUrl');
              this.router.navigateByUrl(this.lastVisitedUrl);
              this.startTour();
            }
          },
          (err: any) => {
            console.log('Error :' + err);
          }
        );
      }

      if (localStorage.getItem('id') != 'undefined') {

        this.utilService.allHeaders.subscribe((allHeaders: any) => {
          this.allHeadersTab = [...allHeaders];

          if (this.allHeadersTab == null || this.allHeadersTab.length == 0) {
            const headers = new HttpHeaders({
              userId: 0,
            });
            this.http
              .post<any>(`${environment.apiUrl}/v1/allHeaders`, null, {
                headers: headers,
              })
              .subscribe((res: any) => {
                this.spinnerService.hide();
                this.isLoading = false;
                const headerResult = res.result;
                this.allHeadersTab = headerResult;
                this.utilService.setAllHeaders(this.allHeadersTab);

                this.differentiateHeaders(this.allHeadersTab);

                this.lastVisitedUrl = localStorage.getItem('lastVisitedUrl');
              });
          } else
            this.differentiateHeaders(this.allHeadersTab);
        });
      } else {
          this.spinnerService.hide();
          this.isLoading = false;
      }
    });
    this.utilService.userName.subscribe((response: any) => {
      let isUserNameEdited = response;
      if (isUserNameEdited) {
        this.getUserDetails();
      }
    });
  }

  getUserDetails() {
    this.auth.user$.subscribe((user) => {
      this.userName = user?.name;

      if (localStorage.getItem('id') != 'undefined') {
        this.homePageService.getUserByAuthId().subscribe(
          (res: any) => {
            const response = res;
            const result = response.result;
            this.userName = result?.firstName + ' ' + result.lastName;
          },
          (err: any) => {
            console.log('Error :' + err);
          }
        );
      }
    });
  }
  ngDoCheck() {
    if (localStorage.getItem('userId')) {
      this.userType = localStorage.getItem('userType');
    }
  }

  callHeader() {
    this.spinnerService.show();
    this.userId = localStorage.getItem('userId');
    this.homePageService.onHeader(this.userId).subscribe((res: any) => {
      const headerResult = res.result;
      this.allHeadersTab = [...headerResult];

      this.differentiateHeaders(this.allHeadersTab);

      this.spinnerService.hide();
      this.isLoading = false;
      if (localStorage.getItem('userId')) {
        this.lastVisitedUrl = localStorage.getItem('lastVisitedUrl');
        this.router.navigateByUrl(this.lastVisitedUrl);
      }
      this.spinnerService.hide();
      this.isLoading = false;
    });
  }

  onLogout() {
    localStorage.removeItem('token');
    this.isHeaderTabVisible = false;
  }

  logout() {
    this.spinnerService.hide();
    this.isLoading = false;
    localStorage.clear();    
    sessionStorage.clear();

    // Clear browser history to prevent back navigation to protected routes
    history.state.userInitiatedLogout = true;
    
    // Navigate to login first to clear the history stack
    this.router.navigate(['/login'], { replaceUrl: true }).then(() => {
      // Then perform Auth0 logout
      this.auth.logout({            
        logoutParams: {
          returnTo: `${window.location.origin}`
        }
      });
    });
  }

   onLoginCall() { 
     localStorage.setItem('lastVisitedUrl', '/login');
     this.router.navigateByUrl("/login");
  }

  onClickSideHeader(sideHeader: any) {
    const sideHeaderPath = sideHeader.headerLinkPath;
    this.router.navigate([sideHeaderPath]);
  }

  onClickManageReq() {
    this.router.navigateByUrl("/manage-requests");
  }

  onClickManageModules() {
    this.router.navigateByUrl("/manage-modules");
  }

  openProfileCard() {
    this.isProfileCardOpen = !this.isProfileCardOpen;
  }

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isProfileCardOpen = false;
    }
  }

  differentiateHeaders(allHeadersTab: any) {
    this.headerTabs = [];
    this.sideHeaders = [];
    this.iconHeaders = [];

    allHeadersTab.forEach((header: any) => {
      if (header.homePageItem) {
        if (header.menuImagePath.includes('_icon.') && header?.isIgnore==false)
          this.iconHeaders.push(header);
        else
          this.headerTabs.push(header);
      } else
        this.sideHeaders.push(header);
        
      if(header?.isIgnore){
            this.modulesForHiddenHeader = [...header.modules];   
      }
    });
  }
  goToAccountSettings() {
    this.router.navigate(['/account-settings'])
  }

  openCopilotApp() {
    this.isUserLoggedIn = localStorage.getItem('id') != 'undefined'
      && localStorage.getItem('id') != undefined ? true : false;  
      
    const token = localStorage.getItem('token');

    let copilotModuleDetails = this.modulesForHiddenHeader[0];
    if (copilotModuleDetails.subscription == false && this.userId && this.isUserLoggedIn) {
      this.getSubscribePopup();
    } else if (copilotModuleDetails.subscription && this.userId && this.isUserLoggedIn) {
      let envValue;
      if (environment.type.includes('dev'))
        envValue = 'dev'
      else if (environment.type.includes('qa'))
        envValue = 'qa'
      else if (environment.type.includes('uat'))
        envValue = 'uat'
      else
        envValue = 'prod'


      const queryParam = btoa(`env=${envValue}&parentToken=${token}`);
      window.open(`${copilotModuleDetails.moduleLink}?${queryParam}`, '_blank');
    } else if (!this.userId && !this.isUserLoggedIn) {
      this.onLoginCall();
    }
  }

  getSubscribePopup() {
    this.errMsg = this.subscriptionMsg;
    this.closeSign = 'OK';
    this.showErrorMessageWithPopup = true;
  }

  onCloseHandler() {
    this.errMsg = null;
    this.showErrorMessageWithPopup = false;
  }

  startTour() {
    this.getAnnouncements()
  }

  getAnnouncements() {
   this.tourService.getAnnouncements().subscribe((res: any) => {
      this.announcementDetails = res.result;
      this.isLoading = false;
      for (const announcement of this.announcementDetails) {
        if (this.router.url.includes(announcement.triggerPageLink)) {
          this.showOverlayFlag = true;
          this.announcementId = announcement.id;
          localStorage.setItem('showTourFlag', this.showOverlayFlag.toString());
          let tourStepsData: any = [];
          announcement.announcementDetails.forEach((step: any) => {
          tourStepsData.push({
          topic: step.title,
          selector: step.selector,
          description: step.content,
          stepNumber: step.stepNumber
        });
        });
          // Sort steps by stepNumber before assigning
          tourStepsData.sort((a: any, b: any) => a.stepNumber - b.stepNumber);
          this.tourSteps = tourStepsData;
          window.scrollTo({ top: 0, behavior: 'auto' }); 
          if(this.tourSteps?.length>0) this.tourService.startTour();
          break;
        } else {
          this.showOverlayFlag = false;
          localStorage.setItem('showTourFlag', this.showOverlayFlag.toString());
        }
      }
    },error=>{
      this.isLoading = false;
      console.error('Error fetching announcements:', error);
      this.showOverlayFlag = false;
      localStorage.setItem('showTourFlag', this.showOverlayFlag.toString());
    });
  }
    ngOnDestroy() {
    if (this.showTourSub) {
      this.showTourSub.unsubscribe();
      document.body.style.overflow = '';
    }
  }

  
}
